import {Dialog, Typography, Box} from '@mui/material'
import styled from 'styled-components'
import theme, {colors} from '../../styles/theme'
import CloseIcon from '@mui/icons-material/Close'

export const StyledDialog = styled(Dialog)`
  margin-bottom: 40px;

  && .MuiDialog-paper {
    border-radius: 5px;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const DialogTitle = styled(Typography)`
  font-size: 32px !important;
  color: #393939 !important;
  justify-content: space-between;
  font-family: Freight Disp Pro !important;
  text-align: center !important;

  ${theme.breakpoints.down('sm')} {
    font-size: 24px !important;
  }
`
export const DialogBox = styled(Box)`
  padding: 40px 32px;
  width: 500px;
  overflow-x: hidden;
  box-sizing: border-box;

  ${theme.breakpoints.down('sm')} {
    width: 100%;
  }

  ${theme.breakpoints.down('xs')} {
    width: auto;
    padding: 24px 20px 20px 20px;
  }
`

export const DialogSubtitle = styled(Typography)`
  font-size: 14px !important;
  color: #393939;
  margin-top: 40px !important;
`

export const DialogText = styled(Box)`
  font-size: 16px !important;
  color: #393939 !important;
  width: fit-content;
  align-items: center;
  margin-top: 20px !important;

  && span {
    display: block;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  && p {
    font-size: 16px !important;
    color: #393939 !important;
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 14px !important;
  }
`

export const ButtonBox = styled(Box)<{$isCentered?: boolean}>`
  display: flex;
  flex-flow: column;
  margin-top: 40px;
  gap: 32px;
  width: 100%;
  justify-content: space-between;

  ${({$isCentered}) =>
    $isCentered
      ? `
      justify-content: center;
    `
      : `justify-content: space-between;`}

  && a {
    width: 100% !important;
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    gap: 24px;

    && a {
      width: 100% !important;
    }
  }
`
export const InputTitle = styled(Typography)`
  font-size: 16px;
  color: #393939 !important;
  margin-bottom: 4px !important;

  && span {
    color: #ff0000;
  }

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

export const StyledDateBox = styled(Box)`
  && {
    .Mui-disabled {
      background: #fafafa;

      &: before {
        border-bottom-style: solid;
      }
    }

    .MuiFilledInput-input {
      padding: 0px 12px !important;
      height: 48px;
      background: #fafafa;
    }

    .MuiInputLabel-filled {
      transform: translate(12px, 14px) scale(1);
    }

    .MuiInputLabel-shrink {
      transform: translate(12px, 5px) scale(0.7);
    }

    .MuiFormHelperText-contained {
      margin-right: 14px;
      margin-left: 0px !important;
    }
  }
`

export const BackButton = styled.div`
  color: ${colors.blue1};
  display: flex;
  gap: 8px;
  font-size: 12px;
  cursor: pointer;
  align-items: center;
`
